import axios from "axios";
import { iappUrl } from "../apirest";

/**
 * Obtiene el NRU del usuario.
 *
 * @param {string} clientid - ID del Cliente.
 * @param {string} courseid - ID del Curso.
 * @param {string} username - Username.
 * @param {string} urlmoodle - URL a la que apunta la API.
 * @returns {Promise<Object|null>} The user NRU data or null if an error occurs.
 */
export async function getUserNru({ clientid, courseid, username, urlmoodle }) {
  try {
    const encodedUrlMoodle = window.btoa(encodeURIComponent(urlmoodle));  
    // todo agregar dos parámetros más, la url a la que tiene que apuntar la api y la id del cliente (la misma id se usará para todo, osea, tomar la id del postype cliente respectivo)
    const url = `${iappUrl}/${clientid}/${courseid}/${username}/${encodedUrlMoodle}`;
    const response = await axios.get(url);
    console.log({ getUserNru: response.data });

    return response.data;
  } catch (err) {
    console.log(err);
    return null;
  }
}
